import { object, string, number, bool } from 'yup';

import useCredentials from 'api/hook/useCredentials';

import { baseAxios, handleError } from 'api';
import { useQuery } from '@tanstack/react-query';

// eslint-disable-next-line no-unused-vars
const OrderScheme = object({
  invoiceId: string().required(),
  total: number().required(),
  amount: number().required(),
  status: string().required().oneOf(['create', 'process', 'success']),
  userId: string().required(),
  qrURL: string().required(),
  isPaid: bool(),
  isSuccess: bool(),
  isError: bool(),
});

/**
 * @typedef {import('yup').InferType<typeof OrderScheme>} TOrder
 *
 * @typedef {object} TDetail
 * @property {any[]} data
 *
 * @typedef {TOrder & TDetail} TOrderDetails
 */

/**
 * @return {import('@tanstack/react-query').UseQueryResult<TOrder, any>}
 */
export function useOrder(invoiceId) {
  const authAxios = useCredentials();

  return useQuery({
    queryKey: ['order', invoiceId],
    queryFn: () => baseAxios(authAxios, { url: 'admin/order/' + invoiceId }),
    onError: handleError,
    refetchInterval: 5000,
    retry: false,
  });
}
